import Immerable from '@naruto/naruto-models/src/types/GeneralImmer';
import { LangConfig, LangAvailableList } from './types';

class I18n extends Immerable {
  public langConfig: LangConfig;

  public langAvailableList: LangAvailableList;

  constructor(langAvailableList: LangAvailableList, defaultLang: number) {
    super();
    this.langConfig = { default: 0, recent: defaultLang };
    this.langAvailableList = langAvailableList;
  }

  t = (key: string): string => {
    let text = '';
    if (this.langAvailableList[this.langConfig.recent]) {
      if (this.langAvailableList[this.langConfig.recent].translate[key]) {
        text = this.langAvailableList[this.langConfig.recent].translate[key];
      }
      if (!text) {
        text = this.langAvailableList[this.langConfig.default].translate[key] || '';
      }
    }
    return text;
  };

  switchLanguage = (availableLanguageValue: string): void => {
    const targetIndex = this.getLanguageIndex(availableLanguageValue);
    if (targetIndex > -1) {
      this.langConfig.recent = targetIndex;
    }
  };

  getLanguageIndex = (languageValue: string): number => {
    const targetIndex = this.langAvailableList.findIndex(ele => ele.value === languageValue);
    return targetIndex;
  };

  resetLanguage = (): void => {
    this.langConfig.recent = this.langConfig.default;
  };

  get currentLanguageValue(): string {
    return this.langAvailableList[this.langConfig.recent].value;
  }

  get languages(): LangAvailableList {
    return this.langAvailableList;
  }
}

export default I18n;
